module.exports = __webpack_public_path__ + "static/media/Johan&Carma(90).3473e907.jpg";